import { Link } from "react-router-dom";

export default function AllTimeCard(props) {
  return (
    <>
      <Link
        to={
          props.allTime.users.length > 1
            ? `/skillzone/group/${props.allTime.bookingReference}`
            : `/skillzone/${props.allTime.bookingReference}`
        }
        state={{ bookingReference: props.allTime.bookingReference }}
        className="w-full flex justify-center hidden sm:block cursor-pointer"
      >
        <div className="w-full bg-[#0A0F2C] text-white p-4 rounded-md mb-2 border-t-8 border-[#4F55F6] flex justify-between items-center shadow-md">
          <div className="w-1/10 flex items-center justify-center">
            {props.allTime.users.length > 1 ? (
              <img
                className="w-7 h-7"
                src={require(`./assets/multiple-avatars.png`)}
                alt="share icon"
              />
            ) : (
              <img
                className="w-4 h-6"
                src={require(`./assets/avatar.png`)}
                alt="share icon"
              />
            )}
          </div>
          <div className="w-1/5 text-sm font-semibold whitespace-normal break-words Kallisto_Bold">
            {props.allTime.users.join(", ")}
          </div>
          <div className="w-1/5 Kallisto_Bold">{props.allTime.date}</div>
          <div className="w-1/5 Kallisto_Bold">{props.allTime.time}</div>
          <div className="text-4xl font-bold ml-4 Kallisto_Bold">
            {props.allTime.score}
          </div>
        </div>
      </Link>

      <Link
        to={
          props.allTime.users.length > 1
            ? `/skillzone/group/${props.allTime.bookingReference}`
            : `/skillzone/${props.allTime.bookingReference}`
        }
        state={{ bookingReference: props.allTime.bookingReference }}
        className="block sm:hidden"
      >
        <div className="bg-[#0A0F2C] text-white rounded-md mb-4 border-t-8 border-[#4F55F6] px-4 py-3 flex items-start justify-start shadow-md">
          <div className="flex-shrink-0 mt-1">
            {props.allTime.users.length > 1 ? (
              <img
                className="w-7 h-7"
                src={require(`./assets/multiple-avatars.png`)}
                alt="share icon"
              />
            ) : (
              <img
                className="w-4 h-6"
                src={require(`./assets/avatar.png`)}
                alt="share icon"
              />
            )}
          </div>

          <div className="flex flex-col ml-10 text-xs sm:text-sm font-semibold Kallisto_Bold leading-tight">
            <div className="mb-4">{props.allTime.users.join(", ")}</div>
            <div>{props.allTime.date}</div>
            <div>{props.allTime.time}</div>
          </div>

          {/* <div className="text-4xl font-bold DrukWideMediumItalic ml-4">
            {props.allTime.score ? props.allTime.score : 1000}
          </div> */}
        </div>
      </Link>
    </>
  );
}
